import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconEventStyle0 = cosmosIconCss;

const CosmosIconEvent$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEvent extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3071e474f66f86862a6120a1c2d69254c849aff7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7ab101bfbdc781b01bf80a08e743a914915f4ede', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a1bc4fa2597fed28a77e1c42c9cf38a5f56fbf30', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 3h-4V2a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v1H9V2a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v1h-4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5Zm-1 14.5h-13v-13h3v1A.5.5 0 0 0 8 6h.5a.5.5 0 0 0 .5-.5v-1h4v1a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-1h3v13Zm-8.59-3.077a.4.4 0 0 1-.2.075c-.147 0-.197-.12-.138-.333l.67-2.317-1.838-1.62c-.112-.096-.154-.163-.154-.246 0-.117.088-.171.304-.192l2.293-.208.926-2.342c.066-.17.133-.242.23-.242.095 0 .158.067.228.242l.926 2.341 2.288.209c.217.02.305.075.305.191 0 .084-.042.15-.155.246l-1.834 1.621.671 2.317c.063.208.013.333-.137.333a.413.413 0 0 1-.2-.075l-2.093-1.37-2.093 1.37Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconEventStyle0; }
}, [1, "cosmos-icon-event", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-event"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-event":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEvent$1);
            }
            break;
    } });
}

const CosmosIconEvent = CosmosIconEvent$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEvent, defineCustomElement };
